<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableElasticBlockStoreResourceListData"
      style="width: 100.1%"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableElasticBlockStoreResourceVue = {};
export default {
  name: "TableElasticBlockStoreResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      accountNameSearchIDVal: "",
      columns: [
        {
          title: this.$t("RAM.AWS.ElasticBlockStorage.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.ElasticBlockStorage.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.ElasticBlockStorage.volumeName"),
          key: "name"
        },
        {
          title: this.$t("RAM.AWS.ElasticBlockStorage.volumeID"),
          key: "volumeAwsId"
        },
        {
          title: this.$t("RAM.AWS.ElasticBlockStorage.volumeCapacity"),
          key: "capacity"
        },
        {
          title: this.$t("RAM.AWS.ElasticBlockStorage.volumeCategory"),
          key: "type"
        },
        {
          title: this.$t("RAM.AWS.ElasticBlockStorage.attachedStatus"),
          key: "stateName"
        },
        {
          title: this.$t("RAM.AWS.ElasticBlockStorage.attachedInstanceID"),
          key: "instanceId"
        },
        {
          title: "IOPS",
          key: "iops"
        }
        // {
        //     title: '快照',
        //     key: 'addressSpace'
        // }
      ],
      tableElasticBlockStoreResourceListData: []
    };
  },
  beforeCreate: function() {
    tableElasticBlockStoreResourceVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("accountName", function(val) {
      tableElasticBlockStoreResourceVue.accountName = val;
    });
    eventBus.$on("companyId", function(val) {
      tableElasticBlockStoreResourceVue.companyId = val;
    });
  },
  mounted: function() {},
  methods: {
    showAll: function() {
      tableElasticBlockStoreResourceVue.getElasticBlockStoreResourceListData();
    },
    // 分页显示数据
    /****************************************************/
    getElasticBlockStoreResourceListData: function() {
      this.$api.resourceManagement
        .pagingQueryVolume({
          accountName: tableElasticBlockStoreResourceVue.accountName,
          companyId: tableElasticBlockStoreResourceVue.companyId,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableElasticBlockStoreResourceListData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableElasticBlockStoreResourceVue.getElasticBlockStoreResourceListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableElasticBlockStoreResourceVue.getElasticBlockStoreResourceListData();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/ebs/TableElasticBlockStoreResource.vue